import catalogEnUSCommon from "../../../../translations/locales/en-US/common.json";
import catalogEnUSNavigation from "../../../../translations/locales/en-US/navigation.json";
import catalogEnUSSchedule from "../../../../translations/locales/en-US/schedule.json";
import catalogEnUSSettings from "../../../../translations/locales/en-US/settings.json";
import catalogEs419Common from "../../../../translations/locales/es-419/common.json";
import catalogEs419Navigation from "../../../../translations/locales/es-419/navigation.json";
import catalogEs419Schedule from "../../../../translations/locales/es-419/schedule.json";
import catalogEs419Settings from "../../../../translations/locales/es-419/settings.json";
import type { TranslationCatalogs } from "../types";

export const I18N_TRANSLATION_CATALOGS = {
  "en-US": {
    common: catalogEnUSCommon,
    navigation: catalogEnUSNavigation,
    schedule: catalogEnUSSchedule,
    settings: catalogEnUSSettings,
  },
  "es-419": {
    common: catalogEs419Common,
    navigation: catalogEs419Navigation,
    schedule: catalogEs419Schedule,
    settings: catalogEs419Settings,
  },
} as const satisfies TranslationCatalogs;
